/*
  Discount code field for the cart drawer and cart page (snippets/cart-discount.liquid).
  Saves codes onto the cart with /cart/update.js so they show in cart totals and carry into
  checkout, and so assets/towel-gift.js can add the gift towel when its code is applied.
*/
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); });
  }

  function money(cents, format) {
    var value = ((Number(cents) || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, value);
  }

  function findCode(cart, code) {
    var wanted = code.toUpperCase();
    return (cart.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === wanted; })[0];
  }

  class CartDiscount extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.cart-discount-field__input');
      this.button = this.querySelector('.cart-discount-field__apply');
      this.msg = this.querySelector('.cart-discount-field__msg');
      this.list = this.querySelector('.cart-discount-field__codes');
      this.codes = [];

      this.button.addEventListener('click', () => this.apply());
      // The cart page wraps this in the cart <form>; stop Enter submitting it.
      this.input.addEventListener('keydown', (evt) => {
        if (evt.key === 'Enter') {
          evt.preventDefault();
          this.apply();
        }
      });
      this.list.addEventListener('click', (evt) => {
        var remove = evt.target.closest('[data-remove-code]');
        if (remove) this.update(this.codes.filter((c) => c !== remove.dataset.removeCode));
      });

      this.boundLoad = this.load.bind(this);
      document.addEventListener('on:cart:change', this.boundLoad);
      this.load();
    }

    disconnectedCallback() {
      document.removeEventListener('on:cart:change', this.boundLoad);
    }

    load() {
      getCart().then((cart) => this.render(cart)).catch(() => {});
    }

    render(cart) {
      this.codes = (cart.discount_codes || []).map((d) => d.code);
      this.list.innerHTML = '';
      (cart.discount_codes || []).forEach((d) => {
        var li = document.createElement('li');
        li.className = 'cart-discount-field__code' + (d.applicable ? '' : ' cart-discount-field__code--inactive');
        var label = document.createElement('span');
        label.textContent = d.code;
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.dataset.removeCode = d.code;
        remove.setAttribute('aria-label', 'Remove ' + d.code);
        remove.innerHTML = '&times;';
        li.append(label, remove);
        this.list.appendChild(li);
      });
      this.list.hidden = !this.codes.length;
    }

    say(text, type, removeCode) {
      this.msg.textContent = text || '';
      this.msg.dataset.type = type || '';
      if (removeCode) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cart-discount-field__remove';
        btn.textContent = 'Remove code';
        btn.addEventListener('click', () => this.update(this.codes.filter((c) => c.toUpperCase() !== removeCode.toUpperCase())));
        this.msg.append(' ', btn);
      }
    }

    apply() {
      var code = this.input.value.trim();
      if (!code) {
        this.say('Enter a discount code.', 'error');
        return;
      }
      if (this.codes.some((c) => c.toUpperCase() === code.toUpperCase())) {
        this.say('That code is already applied.', 'error');
        return;
      }
      this.say('Checking ' + code.toUpperCase() + '…');
      this.update(this.codes.concat(code), code, true);
    }

    // Replace the cart's codes with `codes`. `added` is the code just entered, if any.
    update(codes, added, keepMessage) {
      this.button.disabled = true;
      this.button.textContent = 'Applying…';
      if (!keepMessage) this.say('');

      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      })
        .then((res) => {
          if (!res.ok) throw new Error(res.status);
          // Let the towel gift add its line first, so the gift code reads as valid.
          return window.D1TowelGift ? window.D1TowelGift.sync().then(getCart) : res.json();
        })
        .then((cart) => {
          this.render(cart);
          if (added) {
            var applied = findCode(cart, added);
            var shown = added.toUpperCase();
            if (applied && applied.applicable) {
              this.input.value = '';
              var saved = Math.max(0, (cart.original_total_price || 0) - (cart.total_price || 0));
              this.say(shown + ' applied: −' + money(saved, this.dataset.moneyFormat) + '.', 'success', added);
            } else {
              this.say(shown + ' can’t be applied to this cart. Check the code, or continue without it.', 'error');
              // Don't leave a rejected code on the cart.
              this.update(codes.filter((c) => c !== added), null, true);
              return;
            }
          }
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        })
        .catch(() => this.say('Something went wrong. Please try again.', 'error'))
        .then(() => { this.button.disabled = false; this.button.textContent = 'Apply'; });
    }
  }

  if (!customElements.get('cart-discount')) customElements.define('cart-discount', CartDiscount);
})();
